/* ============================================================================
   WonderCases — Thumbnail ↔ Hero sync (DOM-truth based)
   ----------------------------------------------------------------------------
   - Ahelyett, hogy csak variant eventekre támaszkodnánk, mindig azt nézzük:
     MELYIK hero media-item látszik ténylegesen a DOM-ban.
   - Így ha a téma saját gallery scriptje felülírja az állapotot, mi utána
     is helyre tudjuk húzni az aktív thumbnailt.
   - Működik desktop + mobile esetén is.
   ============================================================================ */

document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-section-type="product"]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id') || '';
  var variantsById = {};
  var lastVariantChangeAt = 0; // ezzel különítjük el a "variant change" vs "csak hero slide" esetét
  var pendingSync = null;

  /* ---------- Product JSON betöltés (fallback, ha kell a featured_media) ---------- */
  (function loadProductJson() {
    if (!sectionId) return;
    var node = document.getElementById('ProductJson-' + sectionId);
    if (!node) return;
    try {
      var productData = JSON.parse(node.textContent);
      if (productData && Array.isArray(productData.variants)) {
        productData.variants.forEach(function (v) {
          variantsById[String(v.id)] = v;
        });
      }
    } catch (e) {
      console.warn('[WC thumb-sync] Failed to parse ProductJson', e);
    }
  })();

  function getCurrentVariantFromForm() {
    var idInput =
      root.querySelector('input[name="id"][type="hidden"]') ||
      root.querySelector('select[name="id"]');

    if (!idInput) return null;
    var id = String(idInput.value || '');
    return variantsById[id] || null;
  }

  /* ---------- Hero media → mediaId felderítés (DOM alapján) ---------- */

  function findHeroMediaElement() {
    // Desktop hero: ami NEM hidden, NEM wc-variant-hidden
    var desktopActive = root.querySelector(
      '.product__media-container.above-mobile .product__media-item[data-product-media-wrapper]:not(.hidden):not(.wc-variant-hidden)'
    );
    if (desktopActive) return desktopActive;

    // Ha desktopon nem találunk, nézzük a mobile slider közepén lévő itemet
    var mobileMedia = root.querySelector(
      '.product__media-container.below-mobile .product__media'
    );
    if (!mobileMedia) return null;

    var items = mobileMedia.querySelectorAll(
      '.product__media-item[data-product-media-wrapper]'
    );
    if (!items.length) return null;

    var containerRect = mobileMedia.getBoundingClientRect();
    var centerX = containerRect.left + containerRect.width / 2;
    var bestItem = null;
    var bestDist = Infinity;

    items.forEach(function (item) {
      var r = item.getBoundingClientRect();
      var mid = r.left + r.width / 2;
      var dist = Math.abs(mid - centerX);
      if (dist < bestDist) {
        bestDist = dist;
        bestItem = item;
      }
    });

    return bestItem;
  }

  function findHeroMediaId() {
    var heroEl = findHeroMediaElement();
    if (!heroEl) return null;
    return (
      heroEl.getAttribute('data-media-item-id') ||
      heroEl.getAttribute('data-media-id') ||
      null
    );
  }

  /* ---------- Thumb állapot beállítása adott mediaId alapján ---------- */

  function setActiveThumbsByMediaId(mediaId, options) {
    if (!mediaId) return;
    mediaId = String(mediaId);
    options = options || {};

    var allThumbButtons = root.querySelectorAll(
      '.product-thumbnails__item-link'
    );

    // Régi aktív state-ek törlése
    allThumbButtons.forEach(function (btn) {
      btn.classList.remove(
        'product-thumbnails__item--active',
        'active',
        'is-active',
        'current'
      );
      btn.removeAttribute('aria-current');

      var li = btn.closest('.product-thumbnails__item');
      if (li) {
        li.classList.remove(
          'product-thumbnails__item--active',
          'is-active',
          'current',
          'wc-variant-thumb-current'
        );
      }
    });

    // Új aktív thumb(ok)
    var thumbButtons = root.querySelectorAll(
      '.product-thumbnails__item-link[data-media-id="' + mediaId + '"]'
    );
    if (!thumbButtons.length) {
      if (window.WC_DEBUG_THUMBS) {
        console.warn('[WC thumb-sync] No thumb found for mediaId', mediaId);
      }
      return;
    }

    thumbButtons.forEach(function (btn) {
      btn.classList.add(
        'product-thumbnails__item--active',
        'active',
        'is-active',
        'current'
      );
      btn.setAttribute('aria-current', 'true');

      var li = btn.closest('.product-thumbnails__item');
      if (li) {
        li.classList.add(
          'product-thumbnails__item--active',
          'is-active',
          'current',
          'wc-variant-thumb-current'
        );
      }

      // Mobil: csak akkor görgessünk, ha ez nagy valószínűséggel variánsváltás miatt történt
      var shouldScrollMobile =
        options.scrollMobile === true ||
        (options.scrollMobile !== false &&
          Date.now() - lastVariantChangeAt < 1500);

      if (shouldScrollMobile) {
        var mobileThumbs = btn.closest(
          '.product-thumbnails[data-thumbnail-size="mobile"]'
        );
        if (mobileThumbs) {
          var rail =
            mobileThumbs.querySelector('.product-thumbnails__items') ||
            mobileThumbs;
          var item = btn.closest('.product-thumbnails__item') || btn;

          if (rail && item && typeof rail.scrollTo === 'function') {
            var railRect = rail.getBoundingClientRect();
            var itemRect = item.getBoundingClientRect();
            var targetScrollLeft =
              rail.scrollLeft +
              (itemRect.left - railRect.left) -
              (railRect.width - itemRect.width) / 2;

            rail.scrollTo({
              left: Math.max(0, targetScrollLeft),
              behavior: 'smooth'
            });
          }
        }
      }
    });
  }

  /* ---------- Sync futtatása (hero → thumb) ---------- */

  function runSync(reason) {
    // 1) próbáljuk a DOM hero alapján
    var mediaId = findHeroMediaId();

    // 2) fallback: aktuális variáns featured_media
    if (!mediaId) {
      var v = getCurrentVariantFromForm();
      if (v && v.featured_media) {
        mediaId = String(v.featured_media.id);
      }
    }

    if (!mediaId) {
      if (window.WC_DEBUG_THUMBS) {
        console.warn('[WC thumb-sync] No mediaId resolved in runSync (' + reason + ')');
      }
      return;
    }

    setActiveThumbsByMediaId(mediaId, {
      // ha kifejezetten variánsváltás volt (timestamp alapján),
      // akkor engedjük a mobile scrollt
      scrollMobile: Date.now() - lastVariantChangeAt < 1500
    });
  }

  function scheduleSync(reason) {
    if (pendingSync) {
      window.cancelAnimationFrame(pendingSync);
      pendingSync = null;
    }

    pendingSync = window.requestAnimationFrame(function () {
      pendingSync = null;
      // kis késleltetés, hogy a téma saját hero/thumbnail logikája már lefusson
      setTimeout(function () {
        runSync(reason);
      }, 60);
    });
  }

  /* ---------- Eventek + MutationObserver ---------- */

  // 1) variant eventek – csak időbélyeg + sync schedule
  var variantEvents = [
    'variant:change',
    'variant:changed',
    'product:variant-change',
    'product:variant:change'
  ];
  variantEvents.forEach(function (evName) {
    document.addEventListener(evName, function () {
      lastVariantChangeAt = Date.now();
      scheduleSync('variant-event:' + evName);
    });
    root.addEventListener(evName, function () {
      lastVariantChangeAt = Date.now();
      scheduleSync('variant-event-root:' + evName);
    });
  });

  // 2) saját WC eventekre is reagálunk, ha máshonnan jön jelzés
  var wcEvents = ['wc:variant-media:change', 'wc:variant-media-change'];
  wcEvents.forEach(function (evName) {
    document.addEventListener(evName, function () {
      lastVariantChangeAt = Date.now();
      scheduleSync('wc-event:' + evName);
    });
    root.addEventListener(evName, function () {
      lastVariantChangeAt = Date.now();
      scheduleSync('wc-event-root:' + evName);
    });
  });

  // 3) Hero DOM figyelése – EZ a kulcs: bárki piszkálja a hero-t, utána szinkronizálunk
  var heroContainers = [];

  var desktopHeroMedia = root.querySelector(
    '.product__media-container.above-mobile .product__media'
  );
  if (desktopHeroMedia) heroContainers.push(desktopHeroMedia);

  var mobileHeroMedia = root.querySelector(
    '.product__media-container.below-mobile .product__media'
  );
  if (mobileHeroMedia) heroContainers.push(mobileHeroMedia);

  if (heroContainers.length && 'MutationObserver' in window) {
    try {
      var observer = new MutationObserver(function (mutations) {
        // itt nem érdekeljük magunkat a részletekkel, csak tudjuk: változott a hero
        scheduleSync('mutation');
      });

      heroContainers.forEach(function (node) {
        observer.observe(node, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['class', 'style']
        });
      });
    } catch (e) {
      console.warn('[WC thumb-sync] MutationObserver failed', e);
    }
  }

  // 4) Thumb manuális kattintás – ilyenkor azonnal highlightolunk, scroll is mehet
  root.addEventListener('click', function (evt) {
    var btn = evt.target.closest(
      '.product-thumbnails__item-link[data-media-id]'
    );
    if (!btn) return;

    var mediaId = btn.getAttribute('data-media-id');
    if (!mediaId) return;

    window.requestAnimationFrame(function () {
      setActiveThumbsByMediaId(mediaId, { scrollMobile: true });
    });
  });

  // 5) Initial sync: oldal betöltés után egyszer
  setTimeout(function () {
    runSync('initial-load');
  }, 200);
});
